module.exports = __webpack_public_path__ + "static/nazarheadshot-d05b619ec292c09d1c3593002e7b19bb.jpg";